var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCIconoEvaluacion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#444;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.5,28.4H1.9a.9.9,0,0,1-.9-.8V4a.9.9,0,0,1,.9-.9H16.8a.9.9,0,0,1,0,1.8H2.8V26.7H24.6V15.3a.9.9,0,0,1,.9-.9.8.8,0,0,1,.8.9V27.6A.8.8,0,0,1,25.5,28.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4,19.6h0a.8.8,0,0,1-.7-.3L8.5,12.9a.9.9,0,0,1,.3-1.3,1,1,0,0,1,1.2.3l3.5,5.3L27.4,1.9a.9.9,0,0,1,1.3-.1.8.8,0,0,1,0,1.2L14.1,19.3A1.5,1.5,0,0,1,13.4,19.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCIconoEvaluacion);
export default __webpack_public_path__ + "static/media/c-icono-evaluacion.86af946d.svg";
export { ForwardRef as ReactComponent };